export default __webpack_public_path__ + "static/media/header-lab-bubble-error-icon.dd115f2f.svg";